<div class="filters-shell">
  <div class="filters-group">
    <div class="field">
      <span class="field-icon"><i class="fa fa-calendar"></i></span>
      <label>Date</label>
      <select [(ngModel)]="dateFilter" (ngModelChange)="dateFilterChange.emit($event); onDateFilterChange.emit()" [disabled]="isLoadingFilters">
        <option *ngFor="let filter of dateFilters" [value]="filter.value">{{filter.label}}</option>
      </select>
    </div>

    <div class="date-range-inline">
      <app-date-range-container [resolvedDateRange]="resolvedDateRange"></app-date-range-container>
    </div>

    <div class="field store-field">
      <span class="field-icon"><i class="fa fa-store"></i></span>
      <label>Store</label>
      <select [(ngModel)]="storeFilter" (ngModelChange)="storeFilterChange.emit($event); onStoreFilterChange.emit()" [disabled]="isLoadingStores">
        <option value="" *ngIf="isLoadingStores">Loading stores...</option>
        <option value="" *ngIf="!isLoadingStores && stores.length === 0">No stores available</option>
        <option *ngFor="let store of stores" [value]="store.id">{{store.name}}</option>
      </select>
    </div>
  </div>

  <div class="filters-group" *ngIf="dateFilter === 'custom'">
    <div class="field">
      <span class="field-icon"><i class="fa fa-arrow-right"></i></span>
      <label>From</label>
      <input type="date" [(ngModel)]="customFromDate" (ngModelChange)="customFromDateChange.emit($event)" [class.required-field]="dateFilter === 'custom' && !customFromDate" />
      <label>To</label>
      <input type="date" [(ngModel)]="customToDate" (ngModelChange)="customToDateChange.emit($event)" [class.required-field]="dateFilter === 'custom' && !customToDate" />
      <button class="btn" (click)="onCustomSearch.emit()" [disabled]="isSearchDisabled" [title]="getSearchButtonTooltip()">Search</button>
    </div>
  </div>
</div>
